import React from "react";
import Upper from "./Upper";
import "./dashboard.scss";
import Down from "./Down";

const Dashboard = () => {
  return (
    <div className="card">
      <Upper />
      <h1 className="Heading">Currently Ongoing Sessions</h1>
      <Down />
    </div>
  );
};

export default Dashboard;
